import React from "react";
import ConfigSection from "../../ConfigSection";

const InvoiceStatusSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Invoice Status'
      configType='InvoiceStatus'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default InvoiceStatusSection;
